import MySquid from '@hub/shared/interfaces/my-squid.interface'
import { BehaviorSubject } from 'rxjs'
export default new BehaviorSubject<MySquid | null>(null)
